import type { Blockchain } from "@anaconda/core/blockchain/types"

export const getBlockchainLabel = (blockchain: Blockchain) =>
  blockchain.charAt(0).toUpperCase() + blockchain.toLowerCase().slice(1)
